import React, {useEffect} from 'react'
import WithAuthentication from "./WithAuthentication"
import createApiServices from "../../services/api/createApiServices"
import {logoutUser} from "../../services/AuthServices"
import {extendUrlIPCC, extentUrlLogin} from "../../store/getUrlLogin"

function EnsureLoggedIn(props) {
    const _api = createApiServices()

    useEffect(() => {
        _api.subscribeErrorRequest(error => {
            const {status, data} = error

            if (status === 403) {
                const {message} = Object.assign({}, data)
                logoutUser(message || '')
            }
        })
        // eslint-disable-next-line
    }, [])

    return (
        <WithAuthentication>
            {
                ({isAuthenticated}) => {
                    if (isAuthenticated) {
                        return props.children
                    } else {
                        window.location.href = `${extentUrlLogin.url}?appCode=ipcc&service=${extendUrlIPCC.url}`
                    }
                }
            }
        </WithAuthentication>
    )
}

export default EnsureLoggedIn
